module.exports = __webpack_public_path__ + "spike-testing.2nCn1-o6.svg";